import type { TarotCard, TarotSpread } from '../types/tarot';

// Complete Tarot Deck (78 cards)
// Generated from database export on 2026-02-01
export const TAROT_DECK: TarotCard[] = [
  {
    id: 'major-0',
    name: 'The Fool',
    arcana: 'major',
    number: 0,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_00_the-fool.webp',
    keywords: [],
    meanings: {
      upright: ["New beginnings","innocence","spontaneity","free spirit"],
      reversed: ["Recklessness","taken advantage of","inconsideration"]
    },
    description: "The Fool represents new beginnings, having faith in the future, being inexperienced, not knowing what to expect, having beginner's luck, improvisation and believing in the universe."
  },
  {
    id: 'major-1',
    name: 'The Magician',
    arcana: 'major',
    number: 1,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_01_the-magician.webp',
    keywords: [],
    meanings: {
      upright: ["Manifestation","resourcefulness","power","inspired action"],
      reversed: ["Manipulation","poor planning","untapped talents"]
    },
    description: "The Magician represents manifestation, resourcefulness, power, and inspired action. It signifies having the tools and ability to achieve your goals."
  },
  {
    id: 'major-2',
    name: 'The High Priestess',
    arcana: 'major',
    number: 2,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_02_the-high-priestess.webp',
    keywords: [],
    meanings: {
      upright: ["Intuition","sacred knowledge","divine feminine","subconscious mind"],
      reversed: ["Secrets","disconnected from intuition","withdrawal"]
    },
    description: "The High Priestess represents intuition, sacred knowledge, and the divine feminine. She encourages you to trust your inner voice."
  },
  {
    id: 'major-3',
    name: 'The Empress',
    arcana: 'major',
    number: 3,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_03_the-empress.webp',
    keywords: [],
    meanings: {
      upright: ["Femininity","beauty","nature","nurturing","abundance"],
      reversed: ["Creative block","dependence on others"]
    },
    description: "The Empress represents femininity, beauty, nature, and abundance. She is the mother figure of the tarot deck."
  },
  {
    id: 'major-4',
    name: 'The Emperor',
    arcana: 'major',
    number: 4,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_04_the-emperor.webp',
    keywords: [],
    meanings: {
      upright: ["Authority","establishment","structure","father figure"],
      reversed: ["Domination","excessive control","lack of discipline"]
    },
    description: "The Emperor represents authority, structure, and control. He is the father figure of the tarot deck."
  },
  {
    id: 'major-5',
    name: 'The Hierophant',
    arcana: 'major',
    number: 5,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_05_the-hierophant.webp',
    keywords: [],
    meanings: {
      upright: ["Spiritual wisdom","religious beliefs","conformity","tradition"],
      reversed: ["Personal beliefs","freedom","challenging the status quo"]
    },
    description: "The Hierophant represents spiritual wisdom, tradition, and conformity. He is the bridge between heaven and earth."
  },
  {
    id: 'major-6',
    name: 'The Lovers',
    arcana: 'major',
    number: 6,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_06_the-lovers.webp',
    keywords: [],
    meanings: {
      upright: ["Love","harmony","relationships","values alignment","choices"],
      reversed: ["Self-love","disharmony","imbalance","misalignment of values"]
    },
    description: "The Lovers represent love, harmony, and relationships. This card is about choices and values alignment."
  },
  {
    id: 'major-7',
    name: 'The Chariot',
    arcana: 'major',
    number: 7,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_07_the-chariot.webp',
    keywords: [],
    meanings: {
      upright: ["Control","willpower","success","action","determination"],
      reversed: ["Self-discipline","opposition","lack of direction"]
    },
    description: "The Chariot represents control, willpower, and determination. It signifies overcoming obstacles through focus."
  },
  {
    id: 'major-8',
    name: 'Strength',
    arcana: 'major',
    number: 8,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_08_strength.webp',
    keywords: [],
    meanings: {
      upright: ["Strength","courage","persuasion","influence","compassion"],
      reversed: ["Inner strength","self-doubt","low energy","raw emotion"]
    },
    description: "Strength represents inner strength, courage, and compassion. It's about gentle control and persuasion."
  },
  {
    id: 'major-9',
    name: 'The Hermit',
    arcana: 'major',
    number: 9,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_09_the-hermit.webp',
    keywords: [],
    meanings: {
      upright: ["Soul searching","introspection","being alone","inner guidance"],
      reversed: ["Isolation","loneliness","withdrawal"]
    },
    description: "The Hermit represents soul searching, introspection, and inner guidance. It's about finding wisdom within."
  },
  {
    id: 'major-10',
    name: 'Wheel of Fortune',
    arcana: 'major',
    number: 10,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_10_wheel-of-fortune.webp',
    keywords: [],
    meanings: {
      upright: ["Good luck","karma","life cycles","destiny","turning point"],
      reversed: ["Bad luck","resistance to change","breaking cycles"]
    },
    description: "The Wheel of Fortune represents cycles, karma, and destiny. It signifies that change is coming."
  },
  {
    id: 'major-11',
    name: 'Justice',
    arcana: 'major',
    number: 11,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_11_justice.webp',
    keywords: [],
    meanings: {
      upright: ["Justice","fairness","truth","cause and effect","law"],
      reversed: ["Unfairness","lack of accountability","dishonesty"]
    },
    description: "Justice represents fairness, truth, and the law. It's about cause and effect and taking responsibility."
  },
  {
    id: 'major-12',
    name: 'The Hanged Man',
    arcana: 'major',
    number: 12,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_12_the-hanged-man.webp',
    keywords: [],
    meanings: {
      upright: ["Pause","surrender","letting go","new perspectives"],
      reversed: ["Delays","resistance","stalling","indecision"]
    },
    description: "The Hanged Man represents pause, surrender, and new perspectives. It's about letting go and seeing things differently."
  },
  {
    id: 'major-13',
    name: 'Death',
    arcana: 'major',
    number: 13,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_13_death.webp',
    keywords: [],
    meanings: {
      upright: ["Endings","change","transformation","transition"],
      reversed: ["Resistance to change","personal transformation","inner purging"]
    },
    description: "Death represents endings, change, and transformation. It's about letting go of the old to make way for the new."
  },
  {
    id: 'major-14',
    name: 'Temperance',
    arcana: 'major',
    number: 14,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_14_temperance.webp',
    keywords: [],
    meanings: {
      upright: ["Balance","moderation","patience","purpose"],
      reversed: ["Imbalance","excess","self-healing","re-alignment"]
    },
    description: "Temperance represents balance, moderation, and patience. It's about finding the middle path."
  },
  {
    id: 'major-15',
    name: 'The Devil',
    arcana: 'major',
    number: 15,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_15_the-devil.webp',
    keywords: [],
    meanings: {
      upright: ["Shadow self","attachment","addiction","restriction","sexuality"],
      reversed: ["Releasing limiting beliefs","exploring dark thoughts","detachment"]
    },
    description: "The Devil represents shadow self, attachment, and restriction. It's about recognizing what binds you."
  },
  {
    id: 'major-16',
    name: 'The Tower',
    arcana: 'major',
    number: 16,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_16_the-tower.webp',
    keywords: [],
    meanings: {
      upright: ["Sudden change","upheaval","chaos","revelation","awakening"],
      reversed: ["Personal transformation","fear of change","averting disaster"]
    },
    description: "The Tower represents sudden change, upheaval, and revelation. It's about breaking down false structures."
  },
  {
    id: 'major-17',
    name: 'The Star',
    arcana: 'major',
    number: 17,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_17_the-star.webp',
    keywords: [],
    meanings: {
      upright: ["Hope","faith","purpose","renewal","spirituality"],
      reversed: ["Lack of faith","despair","self-trust","disconnection"]
    },
    description: "The Star represents hope, faith, and renewal. It's about finding your purpose and believing in the future."
  },
  {
    id: 'major-18',
    name: 'The Moon',
    arcana: 'major',
    number: 18,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_18_the-moon.webp',
    keywords: [],
    meanings: {
      upright: ["Illusion","fear","anxiety","subconscious","intuition"],
      reversed: ["Release of fear","repressed emotion","inner confusion"]
    },
    description: "The Moon represents illusion, fear, and the subconscious. It's about navigating uncertainty and trusting intuition."
  },
  {
    id: 'major-19',
    name: 'The Sun',
    arcana: 'major',
    number: 19,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_19_the-sun.webp',
    keywords: [],
    meanings: {
      upright: ["Positivity","fun","warmth","success","vitality"],
      reversed: ["Inner child","feeling down","overly optimistic"]
    },
    description: "The Sun represents positivity, success, and vitality. It's about joy, warmth, and celebrating life."
  },
  {
    id: 'major-20',
    name: 'Judgement',
    arcana: 'major',
    number: 20,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_20_judgement.webp',
    keywords: [],
    meanings: {
      upright: ["Judgement","rebirth","inner calling","absolution"],
      reversed: ["Self-doubt","inner critic","ignoring the call"]
    },
    description: "Judgement represents rebirth, inner calling, and absolution. It's about self-evaluation and transformation."
  },
  {
    id: 'major-21',
    name: 'The World',
    arcana: 'major',
    number: 21,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_21_the-world.webp',
    keywords: [],
    meanings: {
      upright: ["Completion","integration","accomplishment","travel"],
      reversed: ["Seeking personal closure","short-cuts","delays"]
    },
    description: "The World represents completion, integration, and accomplishment. It's about achieving your goals and wholeness."
  },
  {
    id: 'wands-ace',
    name: 'Ace of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 'ace',
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_22_ace-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Inspiration","new opportunities","growth","potential"],
      reversed: ["Emerging ideas","lack of direction","distractions"]
    },
    description: "The Ace of Wands represents inspiration, new opportunities, and creative potential. It's a sign of new beginnings in creative or spiritual endeavors."
  },
  {
    id: 'wands-2',
    name: 'Two of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 2,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_23_two-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Future planning","progress","decisions","discovery"],
      reversed: ["Personal goals","inner alignment","fear of unknown"]
    },
    description: "The Two of Wands represents planning, progress, and making decisions about your future path. It's about taking the first steps toward your goals."
  },
  {
    id: 'wands-3',
    name: 'Three of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 3,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_24_three-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Progress","expansion","foresight","overseas opportunities"],
      reversed: ["Playing small","lack of foresight","unexpected delays"]
    },
    description: "The Three of Wands represents expansion, foresight, and looking ahead. Your plans are coming to fruition and opportunities are expanding."
  },
  {
    id: 'wands-4',
    name: 'Four of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 4,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_25_four-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Celebration","harmony","marriage","home","community"],
      reversed: ["Personal celebration","inner harmony","conflict with others"]
    },
    description: "The Four of Wands represents celebration, harmony, and homecoming. It's a time of joy, stability, and coming together with loved ones."
  },
  {
    id: 'wands-5',
    name: 'Five of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 5,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_26_five-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Conflict","disagreements","competition","tension"],
      reversed: ["Inner conflict","conflict avoidance","releasing tension"]
    },
    description: "The Five of Wands represents conflict, competition, and tension. Multiple forces are at play, creating challenges and disagreements."
  },
  {
    id: 'wands-6',
    name: 'Six of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 6,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_27_six-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Success","public recognition","progress","self-confidence"],
      reversed: ["Private achievement","personal definition of success","fall from grace"]
    },
    description: "The Six of Wands represents success, recognition, and victory. Your efforts are being acknowledged and you're achieving your goals."
  },
  {
    id: 'wands-7',
    name: 'Seven of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 7,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_28_seven-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Challenge","competition","protection","perseverance"],
      reversed: ["Exhaustion","giving up","overwhelmed"]
    },
    description: "The Seven of Wands represents standing your ground, defending your position, and persevering despite challenges and opposition."
  },
  {
    id: 'wands-8',
    name: 'Eight of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 8,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_29_eight-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Movement","fast paced change","action","alignment"],
      reversed: ["Delays","frustration","resisting change","internal alignment"]
    },
    description: "The Eight of Wands represents swift action, movement, and rapid progress. Things are happening quickly and momentum is building."
  },
  {
    id: 'wands-9',
    name: 'Nine of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 9,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_30_nine-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Resilience","courage","persistence","test of faith"],
      reversed: ["Inner resources","struggle","overwhelm","defensive"]
    },
    description: "The Nine of Wands represents resilience, persistence, and standing strong despite challenges. You're battle-worn but not defeated."
  },
  {
    id: 'wands-10',
    name: 'Ten of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 10,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_31_ten-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Burden","extra responsibility","hard work","completion"],
      reversed: ["Doing it all","carrying the burden","delegation","release"]
    },
    description: "The Ten of Wands represents burden, responsibility, and being overwhelmed. You may be taking on too much or nearing completion of a difficult task."
  },
  {
    id: 'wands-11',
    name: 'Page of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 11,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_32_page-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Inspiration","ideas","discovery","limitless potential","free spirit"],
      reversed: ["Newly formed ideas","redirecting energy","self-limiting beliefs"]
    },
    description: "The Page of Wands represents inspiration, discovery, and new ideas. It's about exploring possibilities with enthusiasm and curiosity."
  },
  {
    id: 'wands-12',
    name: 'Knight of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 12,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_33_knight-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Energy","passion","inspired action","adventure","impulsiveness"],
      reversed: ["Passion project","haste","scattered energy","delays"]
    },
    description: "The Knight of Wands represents passion, energy, and taking inspired action. He charges forward with enthusiasm but may lack planning."
  },
  {
    id: 'wands-13',
    name: 'Queen of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 13,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_34_queen-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Courage","confidence","independence","social butterfly","determination"],
      reversed: ["Self-respect","self-confidence","introverted","re-establish sense of self"]
    },
    description: "The Queen of Wands represents courage, confidence, and determination. She is charismatic, independent, and pursues her goals with passion."
  },
  {
    id: 'wands-14',
    name: 'King of Wands',
    arcana: 'minor',
    suit: 'wands',
    number: 14,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_35_king-of-wands.webp',
    keywords: [],
    meanings: {
      upright: ["Natural leader","vision","entrepreneur","honour"],
      reversed: ["Impulsiveness","haste","ruthless","high expectations"]
    },
    description: "The King of Wands represents natural leadership, vision, and entrepreneurial spirit. He is bold, charismatic, and inspires others."
  },
  {
    id: 'cups-ace',
    name: 'Ace of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 1,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_36_ace-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Love","new relationships","compassion","creativity"],
      reversed: ["Self-love","intuition","repressed emotions"]
    },
    description: "The Ace of Cups represents new love, emotional beginnings, and creative inspiration. It's about opening your heart to new possibilities."
  },
  {
    id: 'cups-2',
    name: 'Two of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 2,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_37_two-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Unified love","partnership","mutual attraction","relationships"],
      reversed: ["Self-love","break-ups","disharmony","distrust"]
    },
    description: "The Two of Cups represents partnership, mutual attraction, and harmonious relationships. It's about connection and unity with another."
  },
  {
    id: 'cups-3',
    name: 'Three of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 3,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_38_three-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Celebration","friendship","creativity","collaborations"],
      reversed: ["Independence","alone time","hardcore partying","'three's a crowd'"]
    },
    description: "The Three of Cups represents celebration, friendship, and joyful gatherings. It's about community, creativity, and shared happiness."
  },
  {
    id: 'cups-4',
    name: 'Four of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 4,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_39_four-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Meditation","contemplation","apathy","reevaluation"],
      reversed: ["Retreat","withdrawal","checking in for alignment"]
    },
    description: "The Four of Cups represents contemplation, apathy, and reevaluation. You may be feeling disconnected or missing opportunities around you."
  },
  {
    id: 'cups-5',
    name: 'Five of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 5,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_40_five-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Regret","failure","disappointment","pessimism"],
      reversed: ["Personal setbacks","self-forgiveness","moving on"]
    },
    description: "The Five of Cups represents loss, regret, and disappointment. It's about grieving what's lost while learning to see what remains."
  },
  {
    id: 'cups-6',
    name: 'Six of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 6,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_41_six-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Revisiting the past","childhood memories","innocence","joy"],
      reversed: ["Living in the past","forgiveness","lacking playfulness"]
    },
    description: "The Six of Cups represents nostalgia, childhood memories, and innocence. It's about reconnecting with your inner child and past joys."
  },
  {
    id: 'cups-7',
    name: 'Seven of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 7,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_42_seven-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Opportunities","choices","wishful thinking","illusion"],
      reversed: ["Alignment","personal values","overwhelmed by choices"]
    },
    description: "The Seven of Cups represents choices, opportunities, and illusions. You may be overwhelmed by options or caught up in fantasies."
  },
  {
    id: 'cups-8',
    name: 'Eight of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 8,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_43_eight-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Disappointment","abandonment","withdrawal","escapism"],
      reversed: ["Trying one more time","indecision","aimless drifting","walking away"]
    },
    description: "The Eight of Cups represents walking away, disappointment, and seeking deeper meaning. It's about leaving behind what no longer serves you."
  },
  {
    id: 'cups-9',
    name: 'Nine of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 9,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_44_nine-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Contentment","satisfaction","gratitude","wish come true"],
      reversed: ["Inner happiness","materialism","dissatisfaction","indulgence"]
    },
    description: "The Nine of Cups represents contentment, satisfaction, and wishes fulfilled. It's about emotional fulfillment and gratitude."
  },
  {
    id: 'cups-10',
    name: 'Ten of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 10,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_45_ten-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Divine love","blissful relationships","harmony","alignment"],
      reversed: ["Disconnection","misaligned values","struggling relationships"]
    },
    description: "The Ten of Cups represents emotional fulfillment, harmony, and happy family life. It's about achieving emotional and spiritual completion."
  },
  {
    id: 'cups-11',
    name: 'Page of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 11,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_46_page-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Creative opportunities","intuitive messages","curiosity","possibility"],
      reversed: ["New ideas","doubting intuition","creative blocks","emotional immaturity"]
    },
    description: "The Page of Cups represents creative opportunities, intuitive messages, and emotional curiosity. It's about being open to new feelings."
  },
  {
    id: 'cups-12',
    name: 'Knight of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 12,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_47_knight-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Creativity","romance","charm","imagination","beauty"],
      reversed: ["Overactive imagination","unrealistic","jealous","moody"]
    },
    description: "The Knight of Cups represents romance, charm, and following your heart. He is the romantic dreamer of the tarot."
  },
  {
    id: 'cups-13',
    name: 'Queen of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 13,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_48_queen-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Compassionate","caring","emotionally stable","intuitive","in flow"],
      reversed: ["Inner feelings","self-care","self-love","co-dependency"]
    },
    description: "The Queen of Cups represents compassion, emotional stability, and intuition. She is nurturing, empathetic, and emotionally mature."
  },
  {
    id: 'cups-14',
    name: 'King of Cups',
    arcana: 'minor',
    suit: 'cups',
    number: 14,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_49_king-of-cups.webp',
    keywords: [],
    meanings: {
      upright: ["Emotionally balanced","compassionate","diplomatic"],
      reversed: ["Self-compassion","inner feelings","moodiness","emotionally manipulative"]
    },
    description: "The King of Cups represents emotional balance, compassion, and diplomacy. He is calm, composed, and emotionally intelligent."
  },
  {
    id: 'swords-ace',
    name: 'Ace of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 1,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_50_ace-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Breakthroughs","new ideas","mental clarity","success"],
      reversed: ["Inner clarity","re-thinking an idea","clouded judgement"]
    },
    description: "The Ace of Swords represents breakthroughs, mental clarity, and new ideas. It's about cutting through confusion with truth and logic."
  },
  {
    id: 'swords-2',
    name: 'Two of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 2,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_51_two-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Difficult decisions","weighing up options","an impasse","avoidance"],
      reversed: ["Indecision","confusion","information overload","stalemate"]
    },
    description: "The Two of Swords represents difficult decisions, stalemate, and avoidance. You may be at a crossroads, unable to choose a path."
  },
  {
    id: 'swords-3',
    name: 'Three of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 3,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_52_three-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Heartbreak","emotional pain","sorrow","grief","hurt"],
      reversed: ["Negative self-talk","releasing pain","optimism","forgiveness"]
    },
    description: "The Three of Swords represents heartbreak, emotional pain, and sorrow. It's about experiencing grief and working through painful emotions."
  },
  {
    id: 'swords-4',
    name: 'Four of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 4,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_53_four-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Rest","relaxation","meditation","contemplation","recuperation"],
      reversed: ["Exhaustion","burn-out","deep contemplation","stagnation"]
    },
    description: "The Four of Swords represents rest, recuperation, and contemplation. It's time to pause, recharge, and gather your strength."
  },
  {
    id: 'swords-5',
    name: 'Five of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 5,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_54_five-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Conflict","disagreements","competition","defeat","winning at all costs"],
      reversed: ["Reconciliation","making amends","past resentment"]
    },
    description: "The Five of Swords represents conflict, defeat, and winning at all costs. It's about the aftermath of battle and hollow victories."
  },
  {
    id: 'swords-6',
    name: 'Six of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 6,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_55_six-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Transition","change","rite of passage","releasing baggage"],
      reversed: ["Personal transition","resistance to change","unfinished business"]
    },
    description: "The Six of Swords represents transition, moving on, and releasing baggage. You're moving from turbulent waters to calmer shores."
  },
  {
    id: 'swords-7',
    name: 'Seven of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 7,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_56_seven-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Betrayal","deception","getting away with something","acting strategically"],
      reversed: ["Imposter syndrome","self-deceit","keeping secrets"]
    },
    description: "The Seven of Swords represents deception, betrayal, and strategic action. Someone may be acting dishonestly or you need to be clever."
  },
  {
    id: 'swords-8',
    name: 'Eight of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 8,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_57_eight-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Negative thoughts","self-imposed restriction","imprisonment","victim mentality"],
      reversed: ["Self-limiting beliefs","inner critic","releasing negative thoughts","open to new perspectives"]
    },
    description: "The Eight of Swords represents feeling trapped, restricted, and powerless. The bonds are often self-imposed and can be removed."
  },
  {
    id: 'swords-9',
    name: 'Nine of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 9,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_58_nine-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Anxiety","worry","fear","depression","nightmares"],
      reversed: ["Inner turmoil","deep-seated fears","secrets","releasing worry"]
    },
    description: "The Nine of Swords represents anxiety, worry, and nightmares. Your mind is creating worst-case scenarios and keeping you awake."
  },
  {
    id: 'swords-10',
    name: 'Ten of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 10,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_59_ten-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Painful endings","deep wounds","betrayal","loss","crisis"],
      reversed: ["Recovery","regeneration","resisting an inevitable end"]
    },
    description: "The Ten of Swords represents painful endings, betrayal, and hitting rock bottom. It's the darkest hour before the dawn."
  },
  {
    id: 'swords-11',
    name: 'Page of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 11,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_60_page-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["New ideas","curiosity","thirst for knowledge","new ways of communicating"],
      reversed: ["Self-expression","all talk and no action","haphazard action","haste"]
    },
    description: "The Page of Swords represents curiosity, new ideas, and thirst for knowledge. He is eager to learn and communicate new concepts."
  },
  {
    id: 'swords-12',
    name: 'Knight of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 12,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_61_knight-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Ambitious","action-oriented","driven to succeed","fast-thinking"],
      reversed: ["Restless","unfocused","impulsive","burn-out"]
    },
    description: "The Knight of Swords represents ambition, action, and driven pursuit of goals. He charges forward with determination but may lack tact."
  },
  {
    id: 'swords-13',
    name: 'Queen of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 13,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_62_queen-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Independent","unbiased judgement","clear boundaries","direct communication"],
      reversed: ["Overly-emotional","easily influenced","bitchy","cold-hearted"]
    },
    description: "The Queen of Swords represents independence, clear thinking, and direct communication. She is honest, perceptive, and unbiased."
  },
  {
    id: 'swords-14',
    name: 'King of Swords',
    arcana: 'minor',
    suit: 'swords',
    number: 14,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_63_king-of-swords.webp',
    keywords: [],
    meanings: {
      upright: ["Mental clarity","intellectual power","authority","truth"],
      reversed: ["Quiet power","inner truth","misuse of power","manipulation"]
    },
    description: "The King of Swords represents mental clarity, intellectual power, and authority. He is logical, analytical, and values truth above all."
  },
  {
    id: 'pentacles-ace',
    name: 'Ace of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 1,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_64_ace-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["A new financial or career opportunity","manifestation","abundance"],
      reversed: ["Lost opportunity","lack of planning and foresight"]
    },
    description: "The Ace of Pentacles represents new financial opportunities, manifestation, and abundance. It's about material beginnings and prosperity."
  },
  {
    id: 'pentacles-2',
    name: 'Two of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 2,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_65_two-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Multiple priorities","time management","prioritisation","adaptability"],
      reversed: ["Over-committed","disorganisation","reprioritisation"]
    },
    description: "The Two of Pentacles represents juggling priorities, adaptability, and finding balance. You're managing multiple responsibilities."
  },
  {
    id: 'pentacles-3',
    name: 'Three of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 3,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_66_three-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Teamwork","collaboration","learning","implementation"],
      reversed: ["Disharmony","misalignment","working alone"]
    },
    description: "The Three of Pentacles represents teamwork, collaboration, and skilled work. It's about working together to achieve common goals."
  },
  {
    id: 'pentacles-4',
    name: 'Four of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 4,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_67_four-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Saving money","security","conservatism","scarcity","control"],
      reversed: ["Over-spending","greed","self-protection"]
    },
    description: "The Four of Pentacles represents security, control, and conservatism. You may be holding on too tightly to money or possessions."
  },
  {
    id: 'pentacles-5',
    name: 'Five of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 5,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_68_five-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Financial loss","poverty","lack mindset","isolation","worry"],
      reversed: ["Recovery from financial loss","spiritual poverty"]
    },
    description: "The Five of Pentacles represents financial hardship, poverty, and isolation. It's about feeling left out in the cold and struggling."
  },
  {
    id: 'pentacles-6',
    name: 'Six of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 6,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_69_six-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Giving","receiving","sharing wealth","generosity","charity"],
      reversed: ["Self-care","unpaid debts","one-sided charity"]
    },
    description: "The Six of Pentacles represents generosity, charity, and sharing wealth. It's about the balance between giving and receiving."
  },
  {
    id: 'pentacles-7',
    name: 'Seven of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 7,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_70_seven-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Long-term view","sustainable results","perseverance","investment"],
      reversed: ["Lack of long-term vision","limited success or reward"]
    },
    description: "The Seven of Pentacles represents patience, perseverance, and long-term investment. You're waiting for your efforts to bear fruit."
  },
  {
    id: 'pentacles-8',
    name: 'Eight of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 8,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_71_eight-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Apprenticeship","repetitive tasks","mastery","skill development"],
      reversed: ["Self-development","perfectionism","misdirected activity"]
    },
    description: "The Eight of Pentacles represents hard work, skill development, and mastery. It's about dedication to your craft and continuous improvement."
  },
  {
    id: 'pentacles-9',
    name: 'Nine of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 9,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_72_nine-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Abundance","luxury","self-sufficiency","financial independence"],
      reversed: ["Self-worth","over-investment in work","hustling"]
    },
    description: "The Nine of Pentacles represents abundance, luxury, and self-sufficiency. You've achieved financial independence through hard work."
  },
  {
    id: 'pentacles-10',
    name: 'Ten of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 10,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_73_ten-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Wealth","financial security","family","long-term success","contribution"],
      reversed: ["The dark side of wealth","financial failure or loss"]
    },
    description: "The Ten of Pentacles represents wealth, financial security, and family legacy. It's about long-term success and generational prosperity."
  },
  {
    id: 'pentacles-11',
    name: 'Page of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 11,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_74_page-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Manifestation","financial opportunity","skill development","new job"],
      reversed: ["Lack of progress","procrastination","learn from failure"]
    },
    description: "The Page of Pentacles represents new financial opportunities, manifestation, and learning. He is practical, ambitious, and eager to learn."
  },
  {
    id: 'pentacles-12',
    name: 'Knight of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 12,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_75_knight-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Hard work","productivity","routine","conservatism","perfectionism"],
      reversed: ["Self-discipline","boredom","feeling 'stuck'","perfectionism"]
    },
    description: "The Knight of Pentacles represents hard work, routine, and methodical progress. He is reliable, responsible, and committed to his goals."
  },
  {
    id: 'pentacles-13',
    name: 'Queen of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 13,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_76_queen-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Nurturing","practical","providing financially","a working parent"],
      reversed: ["Financial independence","self-care","work-home conflict"]
    },
    description: "The Queen of Pentacles represents nurturing, practicality, and financial security. She is grounded, generous, and creates a comfortable home."
  },
  {
    id: 'pentacles-14',
    name: 'King of Pentacles',
    arcana: 'minor',
    suit: 'pentacles',
    number: 14,
    imagePath: '/assets/decorations/card-images/rider-waite/rider-waite_77_king-of-pentacles.webp',
    keywords: [],
    meanings: {
      upright: ["Wealth","business","leadership","security","discipline","abundance"],
      reversed: ["Financially inept","obsessed with wealth and status","stubborn"]
    },
    description: "The King of Pentacles represents wealth, business success, and leadership. He is disciplined, successful, and provides security and abundance."
  }
];

// Tarot Spreads
export const TAROT_SPREADS: TarotSpread[] = [
  {
    id: 'single-card',
    name: 'Single Card',
    description: 'A simple one-card reading for quick guidance',
    cardCount: 1,
    positions: [
      {
        id: 1,
        name: 'Your Card',
        description: 'The guidance you need right now',
        x: 50,
        y: 50
      }
    ]
  },
  {
    id: 'three-card',
    name: 'Past, Present, Future',
    description: 'A classic three-card spread showing the timeline of your situation',
    cardCount: 3,
    positions: [
      {
        id: 1,
        name: 'Past',
        description: 'What has led to this situation',
        x: 25,
        y: 50
      },
      {
        id: 2,
        name: 'Present',
        description: 'Your current situation',
        x: 50,
        y: 50
      },
      {
        id: 3,
        name: 'Future',
        description: 'The likely outcome',
        x: 75,
        y: 50
      }
    ]
  },
  {
    id: 'celtic-cross',
    name: 'Celtic Cross',
    description: 'A comprehensive 10-card spread for deep insight into your situation',
    cardCount: 10,
    positions: [
      { id: 1, name: 'Present Situation', description: 'Your current state and the heart of the matter', x: 50, y: 50 },
      { id: 2, name: 'Challenge', description: 'What crosses you or the main obstacle', x: 50, y: 35 },
      { id: 3, name: 'Distant Past', description: 'Foundation and root causes of the situation', x: 35, y: 50 },
      { id: 4, name: 'Recent Past', description: 'Recent influences and events leading to now', x: 50, y: 65 },
      { id: 5, name: 'Possible Outcome', description: 'What may come to pass if nothing changes', x: 50, y: 20 },
      { id: 6, name: 'Near Future', description: 'Immediate future and next steps', x: 65, y: 50 },
      { id: 7, name: 'Your Approach', description: 'How you approach the situation', x: 85, y: 80 },
      { id: 8, name: 'External Influences', description: 'How others see you and external factors', x: 85, y: 65 },
      { id: 9, name: 'Hopes and Fears', description: 'Your inner feelings and subconscious desires', x: 85, y: 50 },
      { id: 10, name: 'Final Outcome', description: 'The ultimate result and resolution', x: 85, y: 35 }
    ]
  }
];
